import { Spin } from "antd";
import { useDispatch, useSelector } from "react-redux"
import { useGetAssignmentByVideoQuery } from '../../../features/assignments/assignmentsApi'
import { useGetQuizByVideoQuery } from '../../../features/quizzes/quizzesApi';
import { toggleModal } from "../../../features/assignments/assignmentsSlice";
import { toggleModal as toggleQuizModal } from "../../../features/quizzes/quizzesSlice";
import AssignmentSubmitForm from "./AssignmentForm";
import QuizSubmitForm from "./QuizForm";


export default function CoursePlayer() {
  const dispatch = useDispatch()
  const { activeVideo } = useSelector(state => state.videos);

  const { data: assignments } = useGetAssignmentByVideoQuery(activeVideo?.id)
  const { data: quizzes } = useGetQuizByVideoQuery(activeVideo?.id)

  const { id = null, title, url, description, createdAt } = activeVideo || {}
  const openAssignment = () => {
    dispatch(toggleModal(true))
  }

  const openQuiz = () => {
    dispatch(toggleQuizModal(true))
  }
  return (

    <div className="col-span-full w-full space-y-8 lg:col-span-2">
      {
        activeVideo && id ?
          <>
            <iframe width="100%" className="aspect-video"
              src={`${url}?autoplay=true`}
              title={title}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen ></iframe >

            <div>
              <h1 className="text-lg font-semibold tracking-tight text-slate-100">
                {title}
              </h1>
              <h2 className=" pb-4 text-sm leading-[1.7142857] text-slate-400">
                Uploaded on {new Date(createdAt).toLocaleDateString()}</h2>

              <div className="flex gap-4">
                {assignments?.length ?
                  <div onClick={openAssignment} className="cursor-pointer px-3 font-bold py-1 border border-cyan text-cyan 
                                  rounded-full text-sm hover:bg-cyan hover:text-primary">
                    এসাইনমেন্ট
                  </div> : null
                }

                {quizzes?.length ?
                  <div onClick={openQuiz} className="px-3 cursor-pointer font-bold py-1 border border-cyan 
                                  text-cyan rounded-full text-sm hover:bg-cyan hover:text-primary">
                    কুইজে অংশগ্রহণ করুন
                  </div> : null
                }
              </div>
              <p className="mt-4 text-sm text-slate-400 leading-6">
                {description}
              </p>
            </div>
          </>
          :
          <div className="w-full h-full flex justify-center items-center">
            <Spin />
          </div>
      }
      {assignments?.length ?
        <AssignmentSubmitForm assignment={assignments[0]} /> : null
      }
      {quizzes?.length ?
        <QuizSubmitForm quizzes={quizzes} video={activeVideo} /> : null
      }
    </div >
  )
}